import { Component, input, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';
import { CommonModule } from '@angular/common';
import { StaggeredSplitTextDirective } from '../../directives/staggered-split-text.directive';

export interface BreadcrumbItem {
  label: string;
  route?: string;
  isActive?: boolean;
}

@Component({
  selector: 'app-page-header',
  imports: [RouterLink, AnimateOnScrollDirective, CommonModule, StaggeredSplitTextDirective],
  templateUrl: './page-header.html',
  styleUrl: './page-header.scss',
})
export class PageHeader {
  // Input properties for customization
  title = input<string>('Page Title');
  breadcrumbs = input<BreadcrumbItem[]>([
    { label: 'Home', route: '/' },
    { label: 'Current Page', isActive: true }
  ]);
  backgroundImage = input<string>('https://solvior.themejunction.net/wp-content/uploads/2025/04/pheader-bg.webp');
  
  isVisible = signal(false);
  
  // Split title into characters for animation
  get titleCharacters(): string[] {
    return this.title().split('');
  }
}
